export const DERIVATIONS_ROUTES = {
  interconsultations                   : 'interconsultas',
  nextControl                          : 'programar/control',
  historyPatientInterconsultations     : 'historial/paciente',
  historyProfessionalInterconsultations: 'historial/profesional',
};
